// -- Import only the relevant firebase packages or it complains at you.
import * as firebase from 'firebase/app';
import 'firebase/database';

import Message from '../Models/Message/Message';
import User from '../Models/User/User';

var config = {
    apiKey: "AIzaSyD34YoO-epR0tIUvNaHJf11PQ7FyT8NAuU",
    authDomain: "cca-chat-f11c9.firebaseapp.com",
    databaseURL: "https://cca-chat-f11c9.firebaseio.com",
    projectId: "cca-chat-f11c9",
    storageBucket: "cca-chat-f11c9.appspot.com",
    messagingSenderId: "283494687384"
};

class FirebaseService {
    private _db: firebase.database.Database = null;
    private _room: string = null;
    private _user: User = null;
    private _userStatusDatabaseRef: firebase.database.Reference = null;
    private _userLinkNameDatabaseRef: firebase.database.Reference = null;
    private _userDatabaseRef: firebase.database.Reference = null;

    public set user(val: User) {
        this._user = val;
    }

    public get user(): User {
        return this._user;
    }

    public set room(val:string) {
        this._room = val;
    }

    public get room(): string {
        return this._room;
    }

    init(room: string, user: User) {
        firebase.initializeApp(config);
        this._db = firebase.database();
        this._room = room;
        this._user = user;
        this._userStatusDatabaseRef = this._db.ref(this._room + '/users/' + this._user.username + '/status')
        this._userLinkNameDatabaseRef = this._db.ref(this._room + '/users/' + this._user.username + '/userLinkName')
        this._userDatabaseRef = this._db.ref(this._room + '/users/' + this._user.username)
    }

    setupFirebaseSync(callBack: (data: any) => void): void {
        this._db.ref(this._room).on('value', (snapshot: firebase.database.DataSnapshot) => {
            callBack(snapshot);
        })
    }

    addChatMessage(message: string): void {
        const msg = new Message(message, this._user.username, this._user.userLinkName, Date.now(), this._room);
        this._db.ref(this._room + '/messages').push(msg);
    }

    setupUserListeners(callBack?: (users: User[]) => void): void {
        this._userStatusDatabaseRef.set('online');
        this._userLinkNameDatabaseRef.set(this._user.userLinkName);
    }

    setupLeaveListeners(): void {
        this._userStatusDatabaseRef.set('offline');
    }
}

export default new FirebaseService();